import { render, staticRenderFns } from "./ShieldLock.vue?vue&type=template&id=274e62fc&"
import script from "./ShieldLock.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ShieldLock.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports